import axios from 'axios';

const react_app_api_url = window._config?.REACT_APP_API_URL || process.env.REACT_APP_API_URL;

const http = axios.create({
  baseURL: `${react_app_api_url}api`,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
});

const httpMultiPart = axios.create({
  baseURL: `${react_app_api_url}api`,
  headers: {
    'Content-Type': 'multipart/form-data',
  },
})

export const api = {
  get: (url, id) => http.get(url + id),
  getAll: url => http.get(url),
  post: (url, o) => http.post(url, o),
  put: (url, o, id) => http.put(`${url}${id || ''}`, o),
  delete: (url, id) => http.delete(url + id),
  deleteData: (url, data) => http.delete(url, { data }),
  getWithParam: (url, o) => http.get(url, o),
  upload: (url, data) => httpMultiPart.post(url, data),
  getBlob: (url) => http.get(url, { responseType: 'blob' }),
  getHocCardTranslate: (url, o) => http.get(url, o),
  translate: {
    get: (url, language) => http.get(`${url}/hocCardTranslate`, language)

  },// RITM0954296-HOCCardTranslate
};

export const fileUpload = {
  post: (data, onUploadProgress) => httpMultiPart.post(
    `options/upload`, data, { onUploadProgress: onUploadProgress })
};
